<template>
	<div class="combobox-with-validations">
		<div :class="classObject">
			<select
				:value="value_"
				:id="id_"
				:name="name_"
				class="mcombobox"
				:disabled="disabled"
				v-bind="attrs"
				@change="changeSelected($event.target.value)"
			>
				<option
					v-for="option in allOptions"
					:value="option.value"
					:selected="option.value === value_"
					:disabled="option.disabled"
					:key="option.value"
					v-bind="option.hasOwnProperty('attrs') ? option.attrs : {}"
				>
					{{ option.label }}
				</option>
			</select>
			<label></label>
		</div>
		<MErrors v-if="errors_" :errors="errors_" />
	</div>
</template>

<script>
import find from 'lodash/find';
import { createNameFromVModelExpr } from '../../index';
import MErrors from './MErrors';

export default {
	name: 'MSelect',
	components: { MErrors },
	data() {
		return {
			id_: this.id,
			name_: this.name
		}
	},
	props: {
		id: {
			type: String,
			default: ''
		},
		name: {
			type: String,
			required: true
		},
		attrs: {
			type: Object,
			required: false,
			default() {
				return {}
			}
		},
		defaultOption: {
			type: Object,
			required: false,
			default: null
		},
		options: {
			type: Array,
			required: false,
			default() {
				return [];
			}
		},
		value: {
			type: String,
			required: false,
			default: ''
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false
		},
		errors: {
			type: Object,
			default() {
				return {}
			}
		}
	},
	computed: {
		allOptions() {
			let options = this.options;
			if (
				this.defaultOption !== null &&
				!find(this.options, this.defaultOption)
			)
				options = Array(this.defaultOption, ...this.options);
			return options;
		},
		errors_() {
			return this.errors.getOwnPropertyDescriptor(this.name)
				? this.errors[this.name]
				: false;
		},
		classObject() {
			let classes = ['g2', 'field', 'combobox'];
			if (this.errors_) classes.push('warning');
			return classes;
		},
		value_() {
			return this.value === '' && this.defaultOption
				? this.defaultOption.value
				: this.value;
		}
	},
	created() {
		const id = createNameFromVModelExpr(this);
		const name = this.$vnode.data.model.expression;

		if (id && !this.id_) this.id_ = id;

		if (name && !this.name_) this.name_ = name;
	},
	methods: {
		changeSelected(val) {
			this.$emit('input', val);
		}
	}
}
</script>

<style scoped></style>
